import { z } from 'zod';

import { DiffScopeSchema, DiffStatusSchema } from '../enums.js';

// Building blocks reused by DTOs and event payloads.

export const UuidSchema = z.uuid();
export const IsoDateTimeSchema = z.iso.datetime({ offset: true });
/** A calendar date, `YYYY-MM-DD`. */
export const IsoDateSchema = z.iso.date();

/** BR-032: every alert mutation carries the version the caller saw. */
export const ExpectedVersionSchema = z.object({
  expectedVersion: z.number().int().nonnegative(),
});

/** A row-level rejection reason for malformed files (spec §5.2, BR-023). */
export const RowErrorSchema = z.object({
  row: z.number().int().positive(),
  msg: z.string(),
});
export type RowError = z.infer<typeof RowErrorSchema>;

/** Parent path of a BOM line: the part numbers from the top assembly down, `/`-joined. */
export const ParentPathSchema = z.string();

/**
 * One classified line from a detection run (spec §5.3). The status says what the ERP needs to
 * match the released PDM revision (ADR 0009): Added is in PDM and missing in ERP, Removed is
 * extra in ERP, Moved sits under a different parent in PDM (`parentPath`) than in ERP
 * (`movedFromPath`).
 */
export const CompareDiffSchema = z.object({
  scope: DiffScopeSchema,
  parentPath: ParentPathSchema,
  pn: z.string().min(1),
  status: DiffStatusSchema,
  pdmQty: z.number().nullable(),
  erpQty: z.number().nullable(),
  note: z.string().nullable(),
  movedFromPath: ParentPathSchema.nullable(),
  depth: z.number().int().nonnegative(),
  findNo: z.string().nullable(),
  seqNo: z.string().nullable(),
});
export type CompareDiff = z.infer<typeof CompareDiffSchema>;

export const PageQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});
